import I18n from 'I18n';
import { useMemo } from 'react';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalOperation } from '../../types';
import { GATES } from '../../constants/auth';
import { ApprovalErrorAlert } from '../ApprovalErrorAlert';
import ApprovalRulesRadio from '../ApprovalRulesRadio';
import ApproverSelect from '../ApproverSelect';
import ApprovalModalMessage from './ApprovalModalMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ApprovalModalMessageLabelHelpI18n, ApprovalModalMessageLabelI18n } from '../i18n/ApprovalModalMessageLabelI18n';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useGetIsUngated } from '../../hooks/useGetIsUngated';
import { ApprovalDueDateInputGroup } from '../ApprovalDueDateInputGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ApprovalModalBody = ({
  alertContent,
  currentOperation,
  approverOwnerIds,
  errorSubCategory,
  isLoading,
  onChangeApprovers,
  onChangeApprovalRule,
  onChangeNote,
  note,
  dueDate,
  setDueDate,
  dueTime,
  setDueTime,
  isDueDateValid,
  setIsDueDateValid
}) => {
  const approval = useApprovalContext();
  const getHasGate = useGetIsUngated();
  const hasApprovalDueDateGate = getHasGate(GATES.APPROVAL_DUE_DATE);
  const noteIsRequired = useMemo(() => currentOperation === ApprovalOperation.CANCEL || currentOperation === ApprovalOperation.REJECT, [currentOperation]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(TFlex, {
        alignItems: "center",
        justifyContent: "center",
        padding: "300",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {})
      })
    });
  }
  return /*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsxs(View, {
      "data-test-id": "product-approvals-approval-modal-body",
      marginBlockEnd: "300",
      as: "div",
      children: [alertContent && /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        as: "div",
        children: alertContent
      }), errorSubCategory && /*#__PURE__*/_jsx(ApprovalErrorAlert, {
        errorSubCategory: errorSubCategory,
        approvalType: approval.meta.approvalType
      }), /*#__PURE__*/_jsx(ApprovalModalMessage, {})]
    }), currentOperation === ApprovalOperation.REQUEST && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ApproverSelect, {
        value: approverOwnerIds,
        onChange: onChangeApprovers
      }), /*#__PURE__*/_jsx(ApprovalRulesRadio, {
        approvalType: approval.meta.approvalType,
        onChangeApprovalRule: onChangeApprovalRule
      }), hasApprovalDueDateGate && /*#__PURE__*/_jsx(ApprovalDueDateInputGroup, {
        dueDate: dueDate,
        setDueDate: setDueDate,
        dueTime: dueTime,
        setDueTime: setDueTime,
        isDueDateValid: isDueDateValid,
        setIsDueDateValid: setIsDueDateValid
      })]
    }), /*#__PURE__*/_jsx(FormControl, {
      help: /*#__PURE__*/_jsx(ApprovalModalMessageLabelHelpI18n, {
        currentOperation: currentOperation,
        approvalType: approval.meta.approvalType
      }),
      label: /*#__PURE__*/_jsx(ApprovalModalMessageLabelI18n, {
        currentOperation: currentOperation,
        approvalType: approval.meta.approvalType
      }),
      required: noteIsRequired,
      children: /*#__PURE__*/_jsx(TextArea, {
        role: "textbox",
        "data-test-id": `product-approvals-approval-note-${currentOperation}`,
        rows: 4,
        placeholder: I18n.text(noteIsRequired ? 'productApprovals.approvalModalMessagePlaceholder' : 'productApprovals.approvalModalMessagePlaceholderOptional'),
        value: note,
        onChange: onChangeNote
      })
    })]
  });
};